import React, { Component } from 'react';
import Lottie from "lottie-react";
import { Modal, Button } from 'react-bootstrap';
import upload from '../../assets/img/icons/upload.svg';
import Passion from './passion';
import ls from "local-storage";
import axios from 'axios';
import loaderjson from '../../assets/json/loader.json';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Upload extends Component {
    constructor(props) {
        super(props);
        this.fileInput = React.createRef();
        this.handleUpload = this.handleUpload.bind(this);
        this.state = {
            fileUploaded: 'none',
            selectedFile: null,
            previewImage: null,
            passionmodal: false,
            api_url: localStorage.getItem('api_url'),
            langKey: ls.get('LangValue'),
            showLoader: 0,
            image_name: '',
            image_url: '',
        };
    }

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = (e) => {
                this.setState({
                    selectedFile: file,
                    previewImage: reader.result,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    handleUpload () {
        if(this.state.previewImage !== null && this.state.previewImage !== '') {
            const faceId = localStorage.getItem('faceId');
            const faceImage = localStorage.getItem('faceImage');
            const url = this.state.api_url+'uploadimageweb';
            const formData = {
                file: this.state.previewImage,
                faceId: faceId || undefined,
                type: faceId ? 'beforeSignup' : undefined,
                language: this.state.langKey,
            };
            this.setState({
                showLoader: 1
            });
            axios.post(url, formData).then((res) => {
                if (res.data.status === 'true') {
                    const { imageurl: imageUrl, image_name: imageName } = res.data;
                    this.setState({
                        image_name: imageName,
                        image_url: imageUrl,
                        loaderDisplay: false,
                        fileUploaded: 'upload',
                    
                    });
                    localStorage.setItem('image_name', imageName);
                    localStorage.setItem('image_url', imageUrl);
                    this.setState({
                        showLoader: 0,
                    });
                } else {
                    this.setState({ 
                        noupload: res.data.message,
                        fileUploaded: 'none',
                        image_name: '',
                        image_url: '', 
                        showLoader: 1,
                    });
                    localStorage.setItem('image_name', this.state.image_name);
                    localStorage.setItem('image_url', this.state.image_url);
                    setTimeout(() => {
                        this.setState({ noupload: '',showLoader: 0, });
                    }, 2000);
                }
            }).catch((error) => {
                console.error('Image upload failed:', error);
               
            });
        } else {
            this.setState({ noupload: 'Please upload a image' });
            setTimeout(() => {
                this.setState({
                    noupload: '',
                    showLoader: 0,
                });
            }, 2000);
        }
    }

    handlePassionOpenModal = () => {
        this.setState({ passionmodal: true });
    }

    handlePassionCloseModal = () => {
        this.setState({ passionmodal: false });
    }

    render() {
        const { previewImage } = this.state;
        return (
            <div>
                <Modal className="modal_div" show={this.props.showModal} centered>
                    <Modal.Header>
                        <Modal.Title><Trans i18nKey="Upload Great Photos">Upload Great Photos</Trans></Modal.Title>
                        {this.state.fileUploaded === 'upload' && (
                            <div onClick={this.handlePassionOpenModal} className='skip'>
                                <span><Trans i18nKey="Next">Next</Trans></span>
                            </div>
                        )}
                        {this.state.fileUploaded === 'none' && (
                            <div onClick={this.handlePassionOpenModal} className='skip'>
                                <span><Trans i18nKey="Skip">Skip</Trans></span>
                            </div>
                        )}
                    </Modal.Header>
                    <Modal.Body className="religion_modal">
                        <div className='box_upload'>
                            {
                                (this.state.showLoader === 1 
                                ? (<div className='preview_image'>
                                        <img src={previewImage} alt="Preview" className='preview_image' />
                                        <Lottie animationData={(this.state.showLoader === 1) ? loaderjson : ''} className='upload_lottiee' />
                                    </div>) 
                                : previewImage ? (<img src={previewImage} alt="Preview" className='preview_image' />) : ( <img src={upload} alt="Upload Icon" /> )
                                )
                            }
                            <input type="file" accept="image/*" onChange={this.handleFileChange} style={{ display: 'none' }} ref={this.fileInput} />
                            <button onClick={() => this.fileInput.current.click()}><Trans i18nKey="Choose File">Choose File</Trans></button>
                        </div>
                    </Modal.Body>
                    <div className="errorMsg" style={{ paddingLeft: "25px" }}>{this.state.noupload}</div>
                    <Modal.Footer className="forgot_button_plr">
                        <Button className='button_primary' onClick={this.handleUpload}><Trans i18nKey="Add Photos">Add Photos</Trans></Button>
                    </Modal.Footer>
                </Modal>
                <Passion
                    showModal={this.state.passionmodal}
                    handleClose={this.handlePassionCloseModal}
                />
            </div>
        );
    }
}

export default Upload;
